"use client";

import { ErrorPage } from "../ui/blocks/error-page/error-page";
import type { CustomError } from "../utils/error.utils";
import { useErrorHandler } from "../utils/hooks/use-error-handler";

export default function RootError({ error }: { error: CustomError }) {
  const { errorPageProps, onButtonClick } = useErrorHandler({
    error,
    errorTranslations: { button5xx: "Back to login" },
  });

  return <ErrorPage {...errorPageProps} onButtonClick={onButtonClick} />;
}
